import {
  CountryConfig,
  DEFAULT_COUNTRY_CONFIG,
} from '../services/countryConfigService'

/** True when Settings reports Saudi Arabia / SAR. */
export const isSaudiCountry = (
  config: CountryConfig = DEFAULT_COUNTRY_CONFIG
): boolean =>
  config.country.code === 'SA' || config.currency === 'SAR'

/** True when Settings reports Egypt / EGP. */
export const isEgyptCountry = (
  config: CountryConfig = DEFAULT_COUNTRY_CONFIG
): boolean =>
  config.country.code === 'EG' || config.currency === 'EGP'

/**
 * Text currency label for PDFs / invoices / success screens.
 * Egypt → localized ج.م / EGP; otherwise keep existing Saudi text label.
 */
export const getCurrencyTextLabel = (
  config: CountryConfig,
  egyptSymbol: string,
  saudiLabel: string
): string => (isEgyptCountry(config) ? egyptSymbol : saudiLabel)
